import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./App";
import { AuthProvider, useAuth } from "./lib/auth";
import { CampaignProvider } from "./lib/campaign";
import { Login } from "./pages/Login";
import { ResetPassword } from "./pages/ResetPassword";
import { initTheme } from "./lib/theme";
import "./index.css";
import { DialogHost } from "./components/Ask";
import { initChannel } from "./lib/channel";

// Mark the document with its channel (and banner it) before anything renders.
initChannel();

function Gate() {
  const { session, loading, recovery } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted">Loading…</div>;
  if (recovery) return <ResetPassword />;
  if (!session) return <Login />;
  return (
    <CampaignProvider>
      <RouterProvider router={router} />
      <DialogHost />
    </CampaignProvider>
  );
}

initTheme();
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <Gate />
    </AuthProvider>
  </React.StrictMode>
);
